import { DEFAULT_PAGE } from '../../constants/pagination';
import { DEFAULT_SORT_ORDER } from '../../constants/sort';
import { SortOrder } from '../sort/sort';

export interface BusinessReportGetQueryParams {
  date: string;
  sortKey: string;
  sortOrder: SortOrder;
  page: number;
}

export const DefaultBusinessReportGetQueryParams: BusinessReportGetQueryParams =
  {
    date: '',
    sortKey: 'date',
    sortOrder: DEFAULT_SORT_ORDER,
    page: DEFAULT_PAGE,
  };
